<div class="d-flex align-items-center">
  <label [class]="['toggle', 'mx-3', disabled ? 'disabled' : '']">
    <input id="toggle-input" type="checkbox" [formControl]="toggleInput" />
    <span class="toggle-label {{ toggleLabelClass }}">{{ toggleState }}</span>
    <span [class]="['toggle-handle', disabled ? 'disabled' : '']">{{
      toggleHandleText
    }}</span>
  </label>
</div>
